import { Modal } from 'ant-design-vue';

export function showConfirmModal(config: any) {
  return new Promise((resolve) => {
    Modal.confirm({
      ...config,
      okText: config.okText || '确认',
      cancelText: config.cancelText || '取消',
      onOk: () => {
        resolve(true);
      },
      onCancel: () => {
        resolve(false);
      },
    });
  });
}
